const MailSvg = ({ size = '14px' }) => (
  <svg
    className={`size-[${size}]`}
    viewBox="0 0 12 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_198_23696)">
      <path
        d="M10.5 2.75H1.5C1.40054 2.75 1.30516 2.78951 1.23483 2.85984C1.16451 2.93016 1.125 3.02554 1.125 3.125V9.5C1.125 9.69891 1.20402 9.88968 1.34467 10.0303C1.48532 10.171 1.67609 10.25 1.875 10.25H10.125C10.3239 10.25 10.5147 10.171 10.6553 10.0303C10.796 9.88968 10.875 9.69891 10.875 9.5V3.125C10.875 3.02554 10.8355 2.93016 10.7652 2.85984C10.6948 2.78951 10.5995 2.75 10.5 2.75ZM4.62703 6.5L1.875 9.02234V3.97766L4.62703 6.5ZM5.18203 7.00859L5.74453 7.52656C5.81372 7.59007 5.90421 7.62531 5.99813 7.62531C6.09204 7.62531 6.18253 7.59007 6.25172 7.52656L6.81422 7.00859L9.53297 9.5H2.46422L5.18203 7.00859ZM7.37297 6.5L10.125 3.97719V9.02281L7.37297 6.5Z"
        fill="black"
      />
    </g>
    {/* <defs>
<clipPath id="clip0_198_23696">
<rect width="12" height="12" fill="white" transform="translate(0 0.5)"/>
</clipPath>
</defs> */}
  </svg>
);

export default MailSvg;
